import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/eventTimeZone/importer/eventTimeZoneImporterActions';

export default importerReducers(actions);
